module.exports = __webpack_public_path__ + "static/bigmagic-8fa1eceb731bd749ad1bf0719450b546.png";